<template>
  <b-form-group v-if="formErrors.length">
    <b-alert show variant="danger" class="form-fail">
      <validation-errors :validation-errors="formErrors"/>
    </b-alert>
  </b-form-group>
</template>

<script>
import validationErrors from './validation-errors'

export default {
  components: {
    validationErrors
  },
  props: {
    formErrors: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.form-fail {
  margin: $spacing-md 0
}
</style>



// WEBPACK FOOTER //
// src/components/common/form/form-fail.vue